var _defs, _tspan, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.97945mm",
    height: "132.29167mm",
    viewBox: "0 0 100.97945 132.29167",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-9.0826125e-7,-164.70833)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 68.035713,
    y: 94.404747,
    id: "text4345"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan4343",
    x: 68.035713,
    y: 103.76852,
    style: {
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4392",
    transform: "matrix(1.0427046,0,0,1.0427046,-3.8786942e-8,6.7539861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text108",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26547241px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    "aria-label": "\\uE1F1\\uE1F8\\uE1F3"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path4379",
    d: "m 29.104245,253.70439 c -1.924247,-1.56345 -4.570088,-2.52558 -7.69699,-2.52558 -11.9062818,0 -21.40725409173874,8.77938 -21.40725409173874,18.16009 0,5.65248 4.57008799173874,9.01991 10.46309609173874,9.01991 9.621238,0 21.407254,-9.01991 21.52752,-18.03982 v -79.97654 h -2.886372 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path4381",
    d: "M 64.428469,180.34245 H 31.47573 V 192.369 h 32.952739 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path4383",
    d: "M 63.89103,180.34245 V 192.369 h 30.066368 v 61.21512 c -1.924247,-1.56345 -4.570088,-2.52557 -7.69699,-2.52557 -11.906282,0 -21.407254,8.77938 -21.407254,18.16008 0,5.65248 4.570088,9.01991 10.463096,9.01991 9.621238,0 21.407254,-8.89964 21.52752,-18.03982 v -79.85627 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "text4374",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "61.99864578px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.5499661
    },
    "aria-label": "\\uE882"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4376",
    style: {
      strokeWidth: 1.5499661
    },
    d: "m 63.522172,151.48523 c -4.029912,0 -6.571856,2.72794 -6.571856,5.57988 0,1.05397 0.557987,2.10795 2.107954,2.10795 1.36397,0 2.355948,-1.17797 2.355948,-2.54194 0,-0.68199 -0.309993,-1.17798 -0.619986,-1.48797 -0.309994,-0.30999 -0.557988,-0.49599 -0.557988,-0.86798 0,-0.61999 0.929979,-1.42597 2.665942,-1.42597 1.301971,0 2.541944,0.43399 2.541944,2.16995 0,2.29395 -1.053977,4.7739 -4.959892,6.32386 -4.153909,1.67397 -5.889871,4.15391 -6.757852,7.37784 -0.062,0.372 -0.123997,0.55799 -0.123997,0.74399 0,0.49599 0.309993,0.74398 0.805982,0.74398 0.495989,0 0.743984,-0.24799 0.991978,-0.86798 0.247995,-0.61999 0.557988,-1.11598 1.301972,-1.11598 1.735962,0 2.975935,2.16996 6.261863,2.16996 2.541945,0 3.65792,-1.61197 4.5879,-4.40191 0.123997,-0.30999 0.185996,-0.49599 0.185996,-0.68198 0,-0.37199 -0.371992,-0.55799 -0.743984,-0.55799 -0.309993,0 -0.495989,0.124 -0.743984,0.49599 -0.619986,0.80598 -1.239972,1.11597 -2.107954,1.11597 -1.487967,0 -2.665941,-0.86798 -4.215907,-0.86798 -0.743984,0 -1.425969,0.062 -1.983957,0.31 -0.433991,0.18599 -0.619987,0.30999 -0.805982,0.30999 -0.371992,0 -0.185996,-0.37199 0.185995,-0.86798 1.115976,-1.23997 2.78994,-1.98396 4.711898,-2.41795 3.905914,-0.86798 7.377838,-2.72794 7.377838,-7.06784 0,-2.66595 -2.169952,-4.27791 -5.889871,-4.27791 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtee);
export default __webpack_public_path__ + "static/media/ctee.2acc76cfe78933bd1c13c23e6639e573.svg";
export { ForwardRef as ReactComponent };